import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import Cart from './Cart';
import useAbandonedCartRecovery from './useAbandonedCartRecovery';
import NthFreeQualification from '../../utils/NthFreeQualification';
import PreCartOffers from '../../utils/PreCartOffers';
import { resolveAbandonedCartAttribution } from '../../../utils/abandonedCartAttribution';

// /v3/cart. Restores an abandoned-cart reminder's saved cart first, when the
// link (or the stash that survived login) names one; otherwise renders the
// cart exactly as the route did before. The auth gate mounts this before any
// offers based on the device's old cart.
const CartRoute: FC<RouteComponentProps> = (props) => {
  const recovery = useAbandonedCartRecovery(props.location?.search);
  if (recovery.resolving)
    return <p role="status">Restoring your saved cart…</p>;
  if (recovery.error)
    return (
      <p role="alert">
        We could not restore this saved cart. Your current cart has been kept.
        Please rebuild the saved order using current products.{' '}
        <a
          href="/dashboard"
          onClick={() => resolveAbandonedCartAttribution('')}
        >
          Return to your dashboard
        </a>{' '}
        to continue shopping.
      </p>
    );
  if (recovery.restored) return <Cart {...props} restored />;
  return (
    <NthFreeQualification {...props}>
      <PreCartOffers {...props}>
        <Cart {...props} />
      </PreCartOffers>
    </NthFreeQualification>
  );
};

export default CartRoute;
